import React, { useEffect } from "react";
import { useState } from "react";
import { getSiteRefrence } from "../../api/endpoints/refrences";
import { authSelector } from "../../store/selectors";
import { useSelector } from "react-redux";
import { message } from "antd";
import { deleteSale } from "../../api/endpoints/alert";
import { AiFillDelete } from "react-icons/ai";

export const ComponentToPrint = React.forwardRef(({ item }, ref) => {
  const { access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [debitTotal, setDebitTotal] = useState();
  const [quantityTotal, setQuantityTotal] = useState();
  const [purchaseData, setPurchaseData] = useState([]);

  useEffect(() => {
    // Set the state of leftColumn and rightColumn
    setPurchaseData(item);
  }, [item]);

  const getName = async () => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      console.log(result, "site");
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  useEffect(() => {
    getName();
  });

  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }

  // const handleButtonClick = async (id) => {
  //   try {
  //     const results = await deleteSale(id, access_token);
  //     console.log("Sale deleted successfully:", results);
  //   } catch (error) {
  //     console.error("Error deleting sale:", error);
  //   }
  // };
  const handleButtonClick = async (id) => {
    try {
      const results = await deleteSale(id, access_token);
      if (results.success) {
        // Update the state to remove the deleted entry
        setPurchaseData((prevData) =>
          prevData.filter((item) => item.id !== id)
        );
        message.success("Alert deleted successfully!");
      } else {
        message.error("Failed to delete alert.");
      }
    } catch (error) {
      console.error("Error deleting alert:", error);
      message.error("An error occurred while deleting the alert.");
    }
  };

  return (
    <div ref={ref}>
      <div className=" flex flex-col items-center justify-center">
        <strong>
          {" "}
          <h1 style={{ fontSize: "25px" }}>{siteName}</h1>
        </strong>
        <strong>
          {" "}
          <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
        </strong>

        <strong className="">
          <h1 style={{ fontSize: "17px" }}>Alerts</h1>
        </strong>
      </div>
      <div class="relative mt-5 overflow-x-auto">
        <div className="flex justify-center">
          <div className=" w-11/12">
            <table class="w-full border-b-2 text-sm text-left text-black ">
              <thead class="text-black border-b-2 border-t-2 uppercase   ">
                <tr className="">
                  <th scope="col" class="w-auto  ">
                    {" "}
                    Date{" "}
                  </th>
                  <th scope="col" class="w-auto ">
                    Description
                  </th>
                  <th scope="col" class="w-auto ">
                    Amount
                  </th>
                  <th scope="col" class="w-auto ">
                    Delete
                  </th>
                </tr>
              </thead>

              {purchaseData.length > 0 &&
                purchaseData
                  // .slice()
                  .sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn))
                  .map((ele, i) => {
                    return (
                      <tbody key={i}>
                        {/* Make sure to add a unique key to each row */}
                        <tr className="bg-white dark:bg-gray-800 dark:border-gray-700">
                          <td className="">{ele.enteredOn}</td>
                          <td className="">{ele.description}</td>
                          <td className="">{ele.amount}</td>
                          <td className="">
                            <button onClick={() => handleButtonClick(ele.id)}>
                              <AiFillDelete className="mr-2 mt-1 font-bold" />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
});
